import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { GlobalStyles } from '@mui/system';

import { logger } from '@cutwise/utils';

import AppErrorMessage from '@/dmdrive/core/components/AppErrorMessage/AppErrorMessage';
import NotifyProvider from '@/dmdrive/core/components/NotifyProvider/NotifyProvider';
import { AppError } from '@/dmdrive/core/entities/AppError';
import Root from '@/dmdrive/Root';
import { StoreProvider } from '@/dmdrive/store';
import { globalStyle, theme } from '@/dmdrive/ui-kit/theme';

logger.configure({
  prefix: 'DM-CLOUD',
});

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary fallbackRender={({ error }) => <AppErrorMessage error={new AppError(error)} />}>
    <BrowserRouter>
      <StoreProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          <GlobalStyles styles={globalStyle} />

          <NotifyProvider>
            <Root />
          </NotifyProvider>
        </ThemeProvider>
      </StoreProvider>
    </BrowserRouter>
  </ErrorBoundary>,
);
